/**
 * RBAC Hook
 * 
 * Custom hook to access RBAC context
 */

// cspell:ignore IRBAC
import { useContext } from 'react';
import type { RBACContext as IRBACContext } from '../types/rbac';
import { RBACContext } from '../context/rbacContextInstance';

/**
 * Hook to use RBAC context
 * Must be used within an RBACProvider
 */
export const useRBAC = (): IRBACContext => {
  const context = useContext(RBACContext);
  if (context === undefined) {
    throw new Error('useRBAC must be used within an RBACProvider');
  }
  return context;
};
